import { setDataLayer } from 'shared/constants/datalayer';

export type Location = 'homepage' | 'panel';

export const sendAppInstallCloseEvent = () => {
	setDataLayer({
		event: 'app_install_close',
	});
};

export const sendAppInstallStartEvent = (location: Location) => {
	setDataLayer({
		event: 'app_install_start',
		install_location: location,
	});
};

export const sendAppInstallSuccessEvent = (location: Location) => {
	setDataLayer({
		event: 'app_install_success',
		install_location: location,
	});
};
